/* ==========================================================================
   Bearly Tools kit — assets/bearly-tools-app.js
   Phone "app mode" for every kit tool (≤960px, fit mode on). Pairs with
   assets/bearly-tools-app.css. Off with ?bt_app=0.

   Page state:   hero + upload card + how-to (no pinned preview).
   Editor state: the work area is the WHOLE screen and never resizes.
                 A small floating dock at the bottom holds Back, one button per
                 step, and Download. Tapping a step pops its settings up OVER
                 the work area; tap the step again, the ×, swipe down, or touch
                 the work area to hide it.
                 While a slider is held, the rest of the panel goes see-through
                 so you can watch the change.
   On phones the editor opens by itself as soon as the page loads (upload tools show
   their upload card inside it). Back leaves it for the page, where tapping the preview
   or loading work opens it again. Browser Back closes it without losing work.
   Builds everything from the existing .bt-steps > .bt-step markup, so tools
   need no changes.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('.bt[data-bt]');
  if (!root) return;
  var q = new URLSearchParams(location.search);
  if (q.get('bt_app') === '0' || !root.hasAttribute('data-fit')) return;

  var main = root.querySelector('.bt-main');
  var layout = main && main.querySelector('.bt-layout');
  var canvas = layout && layout.querySelector(':scope > .bt-canvas');
  var stepsEl = layout && layout.querySelector(':scope > .bt-steps');
  if (!main || !layout || !canvas || !stepsEl) return;
  var steps = Array.prototype.slice.call(stepsEl.querySelectorAll(':scope > .bt-step'));
  if (!steps.length) return;

  var mq = matchMedia('(max-width: 960px)');
  var name = root.getAttribute('data-bt-name') || document.title;
  // an upload card = a drop area with its own button (a text-only drop hint doesn't count)
  var drop = (function () {
    var d = canvas.querySelectorAll('.bt-drop, .cy-drop');
    for (var i = 0; i < d.length; i++) if (d[i].querySelector('button, input[type="file"]')) return d[i];
    return null;
  })();
  var active = 0, sheet = 'closed', isApp = false;

  function track(ev, p) { try { if (window.BT && BT.track) BT.track(ev, p || {}); } catch (e) {} }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function text(n) { return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function kick() { dispatchEvent(new Event('resize')); }

  var SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICON_BACK = SVG + '<path d="M15 18l-6-6 6-6"/></svg>';
  var ICON_DL = SVG + '<path d="M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M5 20h14"/></svg>';
  var ICON_X = SVG + '<path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ---------- build ---------- */
  var dock = el('div', 'bt-app-dock');
  var back = el('button', 'bt-app-dock__btn bt-app-dock__back', ICON_BACK);
  back.type = 'button'; back.setAttribute('aria-label', 'Close the editor');
  var tabs = el('div', 'bt-app-tabs'); tabs.setAttribute('role', 'tablist');
  var tabBtns = steps.map(function (s, i) {
    var b = el('button', 'bt-app-tab');
    b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', 'false');
    var n = el('span', 'bt-app-tab__n'); n.textContent = text(s.querySelector('.bt-num')) || String(i + 1);
    var t = el('span', 'bt-app-tab__t'); t.textContent = text(s.querySelector('.bt-step__title')) || ('Step ' + (i + 1));
    b.appendChild(n); b.appendChild(t);
    b.addEventListener('click', function () { onTab(i); });
    tabs.appendChild(b);
    return b;
  });
  var dl = el('button', 'bt-app-dock__btn bt-app-dock__dl', ICON_DL);
  dl.type = 'button'; dl.setAttribute('aria-label', 'Download');
  dock.appendChild(back); dock.appendChild(tabs); dock.appendChild(dl);

  // sheet header: grip + close (the step's own title stays as the heading)
  var grip = el('div', 'bt-app-grip'); grip.setAttribute('aria-hidden', 'true');
  var close = el('button', 'bt-app-close', ICON_X);
  close.type = 'button'; close.setAttribute('aria-label', 'Hide settings');
  stepsEl.insertBefore(close, stepsEl.firstChild);
  stepsEl.insertBefore(grip, stepsEl.firstChild);

  // page state: the tool's own preview is the button. Tap anywhere on it to go full screen.
  var ICON_EXPAND = SVG + '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>';
  var open = el('button', 'bt-app-open',
    '<span class="bt-app-open__pill">' + ICON_EXPAND + '<span class="bt-app-open__title"></span></span>');
  open.type = 'button';
  open.setAttribute('aria-label', 'Open ' + name + ' full screen');

  main.appendChild(dock);
  canvas.appendChild(open);
  if (drop) root.setAttribute('data-has-drop', '');

  /* ---------- settings panel (pops up over the work area) ---------- */
  function setSheet(state) {
    sheet = state;
    root.setAttribute('data-sheet', state);
    root.style.removeProperty('--bt-sheet-y');
    tabBtns.forEach(function (b, k) { b.setAttribute('aria-selected', k === active && state !== 'closed' ? 'true' : 'false'); });
  }
  function setTab(i) {
    active = i;
    steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    if (i === steps.length - 1) root.setAttribute('data-last-tab', ''); else root.removeAttribute('data-last-tab');
    stepsEl.scrollTop = 0;
  }
  function onTab(i) {
    if (i === active && sheet !== 'closed') { setSheet('closed'); track('app_tab', { step: i + 1, sheet: 'closed' }); return; }
    setTab(i);
    setSheet(sheet === 'tall' ? 'tall' : 'open');
    track('app_tab', { step: i + 1, sheet: sheet });
  }
  close.addEventListener('click', function () { setSheet('closed'); });

  // swipe the grip / step title: down hides, up makes it tall
  var drag = null;
  stepsEl.addEventListener('pointerdown', function (e) {
    if (!isApp || sheet === 'closed') return;
    var t = e.target;
    if (!(t === grip || (t.closest && t.closest('.bt-step.is-active > .bt-step__title')))) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    drag = { y: e.clientY, dy: 0 };
    root.setAttribute('data-dragging', '');
    try { stepsEl.setPointerCapture(e.pointerId); } catch (x) {}
  });
  stepsEl.addEventListener('pointermove', function (e) {
    if (!drag) return;
    drag.dy = e.clientY - drag.y;
    root.style.setProperty('--bt-sheet-y', Math.max(-40, drag.dy) + 'px');
    e.preventDefault();
  });
  function endDrag() {
    if (!drag) return;
    var dy = drag.dy; drag = null;
    root.removeAttribute('data-dragging');
    if (dy > 60) setSheet(sheet === 'tall' ? 'open' : 'closed');
    else if (dy < -40) setSheet('tall');
    else setSheet(sheet);
  }
  stepsEl.addEventListener('pointerup', endDrag);
  stepsEl.addEventListener('pointercancel', endDrag);

  // holding a slider: the rest of the panel goes see-through so the work shows
  function scrubEnd() {
    var k = stepsEl.querySelector('.bt-scrub-keep');
    if (k) k.classList.remove('bt-scrub-keep');
    root.removeAttribute('data-scrub');
  }
  stepsEl.addEventListener('pointerdown', function (e) {
    if (!isApp) return;
    var r = e.target.closest && e.target.closest('input[type="range"]');
    if (!r) return;
    var keep = r.closest('.bt-field, .cy-slider, .ss-row, .ws-row') || r.parentNode;
    keep.classList.add('bt-scrub-keep');
    root.setAttribute('data-scrub', '');
  }, true);
  addEventListener('pointerup', scrubEnd, true);
  addEventListener('pointercancel', scrubEnd, true);

  // touching the work area means you're working: the panel gets out of the way
  canvas.addEventListener('pointerdown', function () {
    if (isApp && sheet !== 'closed' && !root.hasAttribute('data-scrub')) setSheet('closed');
  }, true);

  /* ---------- easy sliders on touch screens ----------
     A phone slider normally only moves if your finger lands right on the dot. Here a
     sideways drag anywhere on the slider's row (label, value or track) moves it, by how
     far you drag (it doesn't jump). A tap on the track jumps to that spot. Up/down
     drags still scroll the panel. Fires the same input/change events the tools listen to. */
  var coarse = matchMedia('(pointer: coarse)');
  var ZONE = '.bt-field, .cy-slider, .ss-row, .ws-row';
  var sl = null;
  function rangeFor(t) {
    if (!t || !t.closest) return null;
    var r = t.closest('input[type="range"]');
    if (r) return r;
    var z = t.closest(ZONE);
    if (!z || t.closest('button, select, textarea, input:not([type="range"]), a, label input')) return null;
    var all = z.querySelectorAll('input[type="range"]');
    return all.length === 1 ? all[0] : null;
  }
  function setRange(r, v) {
    var min = parseFloat(r.min), max = parseFloat(r.max), step = parseFloat(r.step);
    if (isNaN(min)) min = 0; if (isNaN(max)) max = 100;
    if (!(step > 0)) step = r.step === 'any' ? 0 : 1;
    v = Math.min(max, Math.max(min, v));
    if (step) v = min + Math.round((v - min) / step) * step;
    var s = String(+v.toFixed(6));
    if (r.value === s) return false;
    r.value = s;
    r.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  }
  root.addEventListener('touchstart', function (e) {
    if (!coarse.matches || e.touches.length !== 1) { sl = null; return; }
    var r = rangeFor(e.target);
    if (!r || r.disabled) { sl = null; return; }
    var t = e.touches[0], rect = r.getBoundingClientRect();
    sl = { r: r, x: t.clientX, y: t.clientY, v: parseFloat(r.value), w: Math.max(40, rect.width), rect: rect,
           onTrack: e.target === r, mode: '', moved: false };
  }, { passive: true, capture: true });
  root.addEventListener('touchmove', function (e) {
    if (!sl) return;
    var t = e.touches[0], dx = t.clientX - sl.x, dy = t.clientY - sl.y;
    if (!sl.mode) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      sl.mode = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (sl.mode === 'y') { sl = null; return; }   // vertical: let the panel scroll
      if (isApp) {
        var keep = sl.r.closest(ZONE) || sl.r.parentNode;
        keep.classList.add('bt-scrub-keep');
        root.setAttribute('data-scrub', '');
      }
    }
    e.preventDefault();
    var min = parseFloat(sl.r.min) || 0, max = parseFloat(sl.r.max); if (isNaN(max)) max = 100;
    if (setRange(sl.r, sl.v + dx / sl.w * (max - min))) sl.moved = true;
  }, { passive: false, capture: true });
  function slEnd() {
    if (!sl) return;
    var s = sl; sl = null;
    if (!s.mode && s.onTrack) {
      // a tap on the track: jump there
      var min = parseFloat(s.r.min) || 0, max = parseFloat(s.r.max); if (isNaN(max)) max = 100;
      if (setRange(s.r, min + (s.x - s.rect.left) / s.rect.width * (max - min))) s.moved = true;
    }
    if (s.moved) s.r.dispatchEvent(new Event('change', { bubbles: true }));
    scrubEnd();
  }
  root.addEventListener('touchend', slEnd, true);
  root.addEventListener('touchcancel', function () { sl = null; scrubEnd(); }, true);

  /* ---------- open / close ---------- */
  function enter(via) {
    if (isApp || !mq.matches) return;
    isApp = true;
    root.setAttribute('data-app', '');
    document.documentElement.classList.add('bt-app-lock');
    setTab(active);
    setSheet(via === 'upload' ? 'open' : 'closed'); // after an upload, show step 1 (e.g. the sticker list) once
    try { history.pushState({ btApp: 1 }, ''); } catch (e) {}
    kick(); setTimeout(kick, 60); setTimeout(kick, 300);
    track('app_open', { via: via });
  }
  function leave(fromPop) {
    if (!isApp) return;
    isApp = false;
    scrubEnd();
    root.removeAttribute('data-app');
    document.documentElement.classList.remove('bt-app-lock');
    if (!fromPop && history.state && history.state.btApp) { try { history.back(); } catch (e) {} }
    refreshOpen();
    kick();
    main.scrollIntoView({ block: 'start' });
    track('app_close', {});
  }
  addEventListener('popstate', function () { if (isApp) leave(true); });
  back.addEventListener('click', function () { leave(false); });
  dl.addEventListener('click', function () {
    setTab(steps.length - 1);
    setSheet(sheet === 'tall' ? 'tall' : 'open');
    track('app_download_tab', {});
  });
  open.addEventListener('click', function () { enter('card'); });

  /* ---------- started? (upload card hidden = work loaded) ---------- */
  function dropHidden() { return !!drop && (drop.hidden || (drop.offsetParent === null && getComputedStyle(drop).display === 'none')); }
  function refreshOpen() {
    open.querySelector('.bt-app-open__title').textContent = root.hasAttribute('data-started') ? 'Tap to keep going' : 'Tap to start';
  }
  if (drop) {
    var was = dropHidden();
    if (was) root.setAttribute('data-started', '');
    new MutationObserver(function () {
      var now = dropHidden();
      if (now && !was) {
        root.setAttribute('data-started', '');
        refreshOpen();
        if (mq.matches && !isApp) enter('upload');
        else if (isApp) { setTab(0); setSheet('open'); kick(); setTimeout(kick, 60); } // uploaded inside the editor: show step 1 once
        else kick();
      }
      was = now;
    }).observe(drop, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
  }
  refreshOpen();

  /* ---------- phone / desktop ---------- */
  function onMq() {
    if (mq.matches) root.setAttribute('data-phone', '');
    else { if (isApp) leave(false); root.removeAttribute('data-phone'); }
    kick();
  }
  if (mq.addEventListener) mq.addEventListener('change', onMq); else mq.addListener(onMq);
  onMq();
  setTab(0);
  setSheet('closed');

  // Phones open straight into the editor: no page step first. Back (or the dock's back
  // button) drops to the page with the hero, how-to and "Tap to start".
  if (mq.matches) enter('auto');
})();
